var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('zj-layout-container',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":_vm.loadingText}},[_c('zj-layout-main',[_c('smartLockerPanelView',{ref:"panel",attrs:{"areaCode":_vm.selectAreaCode},on:{"offLine":_vm.judgeOffline}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }